export default __webpack_public_path__ + "static/media/craft360.9016c5d8.png";